module.exports = __webpack_public_path__ + "static/hero-iic-sm-white-8e040e6f7acc0866f1650009cc2b5e54.png";